// Captures marketing attribution from the landing URL so the client's marketing site and the portal
// stay joined up. Must run before cleanQueryParams() strips params and before the SSO entry handler
// hard-navigates to /service, so it is called from index.js ahead of the first render.

const ATTRIBUTION_KEY = "dc_attribution";

export const MARKETING_PARAMS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
    "fbclid",
    "msclkid",
];

const getReferrerHost = () => {
    try {
        const referrer = document.referrer;
        if (!referrer) return undefined;
        const host = new URL(referrer).host;
        return host && host !== window.location.host ? host : undefined;
    } catch (e) {
        return undefined;
    }
};

// /sso and /link are the two partner entry routes (security/entry/SSO.js and Ext.js): /sso carries a
// one-time auth code, /link is an external link with query parameters and no auth. They are reported
// separately, so they must not collapse into one value. Everything else is an ordinary visit: "link"
// when the address carries parameters (a marketing link), "direct" otherwise.
const getEntryType = (pathname) => {
    const path = (pathname || "").toLowerCase();
    if (path.startsWith("/sso")) return "sso";
    if (path.startsWith("/link")) return "ext";
    return window.location.search ? "link" : "direct";
};

/**
 * Reads attribution off the current URL and stores it for the rest of the tab session. The first
 * capture wins, so an in-flow navigation never overwrites how the visitor originally arrived.
 */
export const captureAttribution = () => {
    try {
        if (sessionStorage.getItem(ATTRIBUTION_KEY)) return getAttribution();

        const params = new URLSearchParams(window.location.search);
        const attribution = { entry_type: getEntryType(window.location.pathname) };

        MARKETING_PARAMS.forEach((name) => {
            const value = params.get(name);
            if (value && value.trim()) attribution[name] = value.trim();
        });

        const referrerHost = getReferrerHost();
        if (referrerHost) attribution.referrer_host = referrerHost;

        sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(attribution));
        return attribution;
    } catch (e) {
        return {};
    }
};

/** Returns the attribution captured on entry, or an empty object when nothing was captured. */
export const getAttribution = () => {
    try {
        const stored = sessionStorage.getItem(ATTRIBUTION_KEY);
        return stored ? JSON.parse(stored) : {};
    } catch (e) {
        return {};
    }
};
